// Mini-preview-uri native ale demo-urilor vorba — un „ecran" forest randat în partea
// vizuală a cardului (ca demo-urile reale). Fără imagini externe / iframe.
// Scalabil: adaugi un demo nou în PREVIEWS; fără preview dedicat → GenericMini.

function Pill({ children, tone = 'cream' }) {
  const tones = {
    honey: 'text-honey bg-honey/15',
    soft: 'text-honey-soft bg-honey-soft/15',
    cream: 'text-cream-soft bg-cream/10',
  }
  return (
    <span className={`rounded px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-wide ${tones[tone]}`}>
      {children}
    </span>
  )
}

function CloseCockpitMini() {
  const rows = [
    ['Seematt Group', 'Submitted', 'cream', '0/4'],
    ['OpCo Zürich', 'In review', 'soft', '3/4'],
    ['OpCo Vienna', 'In review', 'soft', '2/4'],
    ['OpCo Munich', 'Behind', 'honey', '0/4'],
    ['OpCo Amsterdam', 'Behind', 'honey', '0/4'],
  ]
  return (
    <div className="flex h-full flex-col justify-center gap-3 p-6 md:p-8">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-honey">Group close · March 2026</p>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-cream/10">
        <div className="h-full w-1/4 rounded-full bg-honey" />
      </div>
      <p className="font-mono text-[11px] tabular-nums text-cream-soft">
        5/20 signed off · 25% · <span className="text-honey-deep">2 behind</span>
      </p>
      <div className="mt-1 rounded-lg border border-forest-line/70">
        {rows.map(([n, s, t, c], i) => (
          <div
            key={n}
            className={`flex items-center justify-between gap-2 px-3 py-2 ${i ? 'border-t border-forest-line/50' : ''}`}
          >
            <span className="text-[13px] text-cream">{n}</span>
            <span className="flex shrink-0 items-center gap-2">
              <Pill tone={t}>{s}</Pill>
              <span className="font-mono text-[10px] tabular-nums text-cream-muted">{c}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

function ExcelToAppMini() {
  const header = ['Client', 'Amount', 'Status']
  const rows = [
    ['Aurelia SRL', '€ 12,400', true],
    ['Brunner AG', '€ 8,900', true],
    ['Costa Ltd', '€ —', false],
    ['Dorin SA', '€ 21,050', true],
  ]
  return (
    <div className="flex h-full flex-col justify-center p-6 md:p-8">
      <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.18em] text-honey">Spreadsheet → tool</p>
      <div className="overflow-hidden rounded-lg border border-forest-line/70 font-mono text-[11px]">
        <div className="grid grid-cols-3 bg-cream/5 text-cream-muted">
          {header.map((h) => (
            <div key={h} className="px-3 py-2 uppercase tracking-wide">{h}</div>
          ))}
        </div>
        {rows.map((r, i) => (
          <div key={i} className="grid grid-cols-3 border-t border-forest-line/50 text-cream">
            <div className="px-3 py-2">{r[0]}</div>
            <div className="px-3 py-2 tabular-nums">{r[1]}</div>
            <div className="px-3 py-2">
              {r[2] ? <span className="text-honey-soft">✓ Valid</span> : <span className="text-honey">! Missing</span>}
            </div>
          </div>
        ))}
      </div>
      <p className="mt-3 font-mono text-[10px] text-cream-muted">1 row needs attention · roles + validation</p>
    </div>
  )
}

function SalesCrmMini() {
  const rows = [
    ['#1042 · Maria P.', 'Web form', 'New', 'honey'],
    ['#1041 · ACME Inc.', 'Email', 'Quoted', 'soft'],
    ['#1039 · James K.', 'Phone', 'Won', 'cream'],
  ]
  return (
    <div className="flex h-full flex-col justify-center p-6 md:p-8">
      <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.18em] text-honey">Orders · one inbox</p>
      <div className="rounded-lg border border-forest-line/70">
        {rows.map(([who, ch, st, t], i) => (
          <div key={who} className={`flex items-center justify-between gap-2 px-3 py-2 ${i ? 'border-t border-forest-line/50' : ''}`}>
            <span className="flex flex-col">
              <span className="text-[12px] text-cream">{who}</span>
              <span className="font-mono text-[9px] text-cream-muted">{ch}</span>
            </span>
            <Pill tone={t}>{st}</Pill>
          </div>
        ))}
      </div>
      <p className="mt-3 font-mono text-[10px] text-cream-muted">email · phone · forms → one pipeline</p>
    </div>
  )
}

function PeopleOnboardingMini() {
  const steps = [
    ['Offer signed (e-signature)', true],
    ['Equipment assigned', true],
    ['Accounts provisioned', true],
    ['First-week plan sent', false],
  ]
  return (
    <div className="flex h-full flex-col justify-center p-6 md:p-8">
      <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.18em] text-honey">Onboarding · Ana D.</p>
      <div className="rounded-lg border border-forest-line/70">
        {steps.map(([s, done], i) => (
          <div key={s} className={`flex items-center gap-2.5 px-3 py-2 ${i ? 'border-t border-forest-line/50' : ''}`}>
            <span className={done ? 'text-honey-soft' : 'text-cream-muted'}>{done ? '✓' : '○'}</span>
            <span className="text-[12px] text-cream">{s}</span>
          </div>
        ))}
      </div>
      <p className="mt-3 font-mono text-[10px] text-cream-muted">3/4 done · records synced</p>
    </div>
  )
}

function ProcurementMini() {
  const rows = [
    ['Aurelia Inc.', 'Credit OK · active', 'soft'],
    ['Brunner AG', 'Verified', 'soft'],
    ['Costa Ltd', 'Insolvency risk', 'honey'],
  ]
  return (
    <div className="flex h-full flex-col justify-center p-6 md:p-8">
      <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.18em] text-honey">Suppliers · auto-checked</p>
      <div className="rounded-lg border border-forest-line/70">
        {rows.map(([n, s, t], i) => (
          <div key={n} className={`flex items-center justify-between gap-2 px-3 py-2 ${i ? 'border-t border-forest-line/50' : ''}`}>
            <span className="text-[12px] text-cream">{n}</span>
            <Pill tone={t}>{s}</Pill>
          </div>
        ))}
      </div>
      <p className="mt-3 font-mono text-[10px] text-cream-muted">credit · status · insurance · risk</p>
    </div>
  )
}

function GenericMini() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
      <span className="text-2xl text-honey">✦</span>
      <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-cream-muted">Interactive demo</p>
    </div>
  )
}

const PREVIEWS = {
  'close-cockpit': CloseCockpitMini,
  'excel-to-app': ExcelToAppMini,
  'sales-crm': SalesCrmMini,
  'people-onboarding': PeopleOnboardingMini,
  procurement: ProcurementMini,
}

export default function DemoPreview({ demoKey }) {
  const Cmp = PREVIEWS[demoKey] || GenericMini
  return (
    <div className="h-full w-full bg-forest-deep">
      <Cmp />
    </div>
  )
}
